<script setup lang="ts">
defineProps({
  blok: Object,
});

const localePath = useLocalePath();
</script>

<template>
  <section class="flex items-center justify-center relative py-20 max-[641px]:block">
    <div class="w-full h-full absolute top-0 left-0">
      <img :src="blok?.background?.filename" alt="Scorecards" class="w-full h-full object-cover" />
    </div>
    <UiContainer class="flex items-center justify-center">
      <div
        v-motion-slide-visible-once-top
        class="relative w-1/2 bg-chsc-raw p-20 rounded-[40px] max-[769px]:w-full max-[641px]:p-10"
      >
        <div class="global-text text-chsc-indigo-500 text-center">
          <StoryblokRichText :doc="blok?.header" />
        </div>
        <div class="flex justify-center mt-10">
          <UButton :to="localePath('/scorecards')" :label="blok?.cta" size="xl" />
        </div>
      </div>
    </UiContainer>
  </section>
</template>
